module.exports = __webpack_public_path__ + "web/img/z4.a161896c.png";